export class GlobalEMailTemplate {
    internalId: string;
    title: string;
    subject: string;
    body: string;
    fixedNote: string;
    isRequired = false;
    id = 0;
}
